<template>

  <v-container class="noprint">
    <v-layout wrap align-center>
      <v-flex>
        <img height="75" :src="logo" />
      </v-flex>
      <v-flex class="hidden-sm-and-down">
        <v-layout>
          <v-flex text-xs-center>PH-EUT-00098 APR 2024</v-flex>
          <v-flex text-xs-center>
            <router-link to="/privacy/policy">
              Privacy Statement
            </router-link>
          </v-flex>
          <!--<v-flex text-xs-center>Terms</v-flex>-->
          <v-flex text-xs-center>
            <a @click.stop="contactUsDialog = true">Contact Us</a>
          </v-flex>
          <v-flex text-xs-center>Ipadama &copy; 2018</v-flex>
        </v-layout>
      </v-flex>
      <v-flex text-xs-right>
        <v-icon color="primary">mdi-facebook-box</v-icon>
        <v-icon color="primary">mdi-twitter-box</v-icon>
        <v-icon color="primary">mdi-linkedin-box</v-icon>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="contactUsDialog"
      max-width=800
    >
      <v-card>
        <v-card-title>
          <div class="headline">CONTACT US</div>
        </v-card-title>
        <v-card-text>
          You may contact us at <a href="mailto:askeliteonline@gmail.com">askeliteonline@gmail.com</a>.
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>

</template>

<script>
export default {
  data () {
    return {
      contactUsDialog: false,
      logo: require('@/assets/svg/ELITE Logo.svg')
    }
  }
}
</script>
<style type="text/css" media="print">
  @media print
  {
    .noprint {display:none;}
  }
</style>


// WEBPACK FOOTER //
// src/components/mainFooter.vue